<ng-template #shapeTemplate>
    <svg:line *ngIf="hasPoints" attr.x1="{{ lastPoint.x }}" attr.y1="{{ lastPoint.y }}" attr.x2="{{ currentPoint.x }}"
        attr.y2="{{ currentPoint.y }}" [ngStyle]="setStyles()">
    </svg:line>

    <svg:polyline attr.id="{{ shape.shapeProperties.name }}" class="draggable" attr.points="{{ value }}" [ngStyle]="setStyles()">
        <title>{{ shape.shapeProperties.name }}</title>
    </svg:polyline>
</ng-template>